export default "__VITE_ASSET__D06TtuBY__"